import {
  List,
  Datagrid,
  TextField,
  EditButton,
  TextInput,
  Filter,
  NumberField,
  BooleanField,
  FunctionField,
  useTranslate,
  TopToolbar,
  Button as RaButton,
} from "react-admin";
import { Link } from 'react-router-dom';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

const JobApplicationStatusFilter = (props: Record<string, unknown>) => (
  <Filter {...props}>
    <TextInput source="name" label="resources.job-application-status.fields.name" />
  </Filter>
);

const CustomListActions = () => {
  const translate = useTranslate();
  
  return (
    <TopToolbar>
      <RaButton
        component={Link}
        to="/job-application-status-workflow"
        label={translate('resources.job-application-status.workflow.title')}
        startIcon={<AccountTreeIcon />}
      />
    </TopToolbar>
  );
};

export const JobApplicationStatusList = () => {
  const translate = useTranslate();
  
  return (
  <List filters={<JobApplicationStatusFilter />} sort={{ field: "order", order: "ASC" }} actions={<CustomListActions />}>
    <Datagrid bulkActionButtons={false}>
      {/* <TextField source="id" /> */}
      <TextField source="name" />
      <NumberField source="order" />
      <FunctionField
        label="resources.job-application-status.fields.triggersMilestone"
        render={(record: Record<string, unknown>) => {
          if (!record.triggersMilestone) return "-";
          const milestoneKey = String(record.triggersMilestone);
          const translationKey = `resources.job-application-status.milestoneLabels.${milestoneKey}`;
          const translated = translate(translationKey);
          return translated !== translationKey ? translated : milestoneKey;
        }}
      />
      <FunctionField
        label="resources.job-application-status.fields.triggersOutcome"
        render={(record: Record<string, unknown>) => {
          if (!record.triggersOutcome) return "-";
          const outcomeKey = String(record.triggersOutcome);
          const translationKey = `resources.job-application-status.outcomeLabels.${outcomeKey}`;
          const translated = translate(translationKey);
          return translated !== translationKey ? translated : outcomeKey;
        }}
      />
      <BooleanField source="hidesFromKanban" />
      <BooleanField source="isPostHire" />
      <EditButton />
    </Datagrid>
  </List>
  );
};
